"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports.defaultTheme = exports.default = exports.ViewComponent = exports.LinkComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _ButtonView = _interopRequireDefault(require("./components/ButtonView"));
var _TextFieldView = _interopRequireDefault(require("./components/TextFieldView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var types = {
  BUTTON: 'BUTTON',
  TABLE_DOWNLOAD: 'TABLE_DOWNLOAD',
  TABLE_VIEW_COLUMN: 'TABLE_VIEW_COLUMN',
  TEXT_INPUT: 'TEXT_INPUT',
  CUSTOM_ELEM: 'CUSTEM_ELEM',
  LINK: 'LINK',
  ICON: 'ICON',
  TEXT: 'TEXT',
  CONTRAINER: 'CONTRAINER'
};

/**
* configure Link based on configuration
* refer config table (wrapper component config)
*/
exports.types = types;
var LinkComponent = function LinkComponent(props) {
  var url = props.url,
    clsName = props.clsName,
    title = props.title;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Link, {
    href: url,
    className: clsName
  }, title));
};
exports.LinkComponent = LinkComponent;
var Img = function Img(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    clsName = _ref.clsName;
  return /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    alt: alt,
    className: clsName
  });
};
var Text = function Text(_ref2) {
  var text = _ref2.text,
    clsName = _ref2.clsName,
    tag = _ref2.tag,
    Component = _ref2.Component;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: clsName,
    type: tag
  }, text, Component && /*#__PURE__*/_react.default.createElement(Component, null));
};

/**
*
* @param {*}
* @returns custom component based on configuration
*/
var ViewComponent = function ViewComponent(props) {
  var type = props.type,
    customViewElem = props.customViewElem;
  switch (type) {
    case types.BUTTON:
      return /*#__PURE__*/_react.default.createElement(_ButtonView.default, props);
    case types.LINK:
      return /*#__PURE__*/_react.default.createElement(LinkComponent, props);
    case types.ICON:
      return /*#__PURE__*/_react.default.createElement(Img, props);
    case types.TEXT:
      return /*#__PURE__*/_react.default.createElement(Text, props);
    case types.TEXT_INPUT:
      return /*#__PURE__*/_react.default.createElement(_TextFieldView.default, props);
    case types.CUSTOM_ELEM:
      return customViewElem();
    default:
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
};
exports.ViewComponent = ViewComponent;
var defaultTheme = {
  override: {}
};

/**
* creates header and footer components of table
*/
exports.defaultTheme = defaultTheme;
var CustomLayout = function CustomLayout(props) {
  var children = props.children,
    configs = props.configs,
    _props$customTheme = props.customTheme,
    customTheme = _props$customTheme === void 0 ? {} : _props$customTheme;
  /**
  * return when configuration is empty
  */
  if (configs.length === 0) {
    return null;
  }
  /**
  * override default style configuration (please refer to class name table to override styles)
  * 1. props -> {configs, customTheme, section, classes, selectedRows}
  * 2. item -> Component cofiguration defined on cofiguration (refer config table)
  * (attrs - title, eventHandler, clsName, tooltipCofig, conditional)
  */
  var themeConfig = (0, _core.createTheme)({
    overrides: _objectSpread(_objectSpread({}, defaultTheme), customTheme)
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, configs.map(function (container) {
    /**
    * return child/table component
    */
    if (container.paginatedTable) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', children, ' ');
    }
    /**
    * return other wrapper components
    */
    return /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
      theme: themeConfig
    }, /*#__PURE__*/_react.default.createElement(_core.Container, {
      maxWidth: container.size,
      className: container.clsName
    }, container.items.map(function (item) {
      return /*#__PURE__*/_react.default.createElement(ViewComponent, _extends({}, item, props));
    })));
  }));
};
var CustomWrapper = function CustomWrapper(props) {
  var children = props.children,
    _props$wrapConfig = props.wrapConfig,
    wrapConfig = _props$wrapConfig === void 0 ? [] : _props$wrapConfig,
    customTheme = props.customTheme,
    section = props.section,
    classes = props.classes,
    activeFilters = props.activeFilters,
    tblDispatch = props.tblDispatch;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CustomLayout, {
    configs: wrapConfig,
    customTheme: customTheme,
    section: section,
    classes: classes,
    activeFilters: activeFilters,
    tblDispatch: tblDispatch
  }, children));
};
var _default = CustomWrapper;
exports.default = _default;